/* unplugin-vue-components disabled */import { render } from "./ReportShangTong.vue?vue&type=template&id=6c839c43&scoped=true&ts=true"
import script from "./ReportShangTong.vue?vue&type=script&lang=ts"
export * from "./ReportShangTong.vue?vue&type=script&lang=ts"

import "./ReportShangTong.vue?vue&type=style&index=0&id=6c839c43&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c839c43"]])

export default __exports__